import { connect } from 'react-redux';
import { bindActionToPromise } from 'utils/sagaApiGeneratorHelpers';
import { composeEmailActions } from '../../shared/composeEmail/actions/composeEmailActions';
import { EmailTopbarButton } from '../components/email';
const mapStateToProps = (state) => {
    return {
        browser: state.keyboardShortcuts.browser,
        meta: state.composeEmail.meta,
        ui: state.composeEmail.ui,
        fromEmails: state.composeEmail.fromEmails,
        users: state.composeEmail.users,
        profile: state.settings.profile.profile,
        emailDrafts: state.composeEmail.emailDrafts,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        composeEmailOpenModal: (payload) => dispatch(composeEmailActions.composeEmailOpenModal(payload)),
        composeEmailGetDrafts: bindActionToPromise(dispatch, composeEmailActions.composeEmailGetDrafts),
        composeEmailGetAllFrom: bindActionToPromise(dispatch, composeEmailActions.composeEmailGetAllFrom),
        composeEmailRemoveDraft: bindActionToPromise(dispatch, composeEmailActions.composeEmailRemoveDraft),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(EmailTopbarButton);
